module.exports = __webpack_public_path__ + "static/media/zvonko-bitenc-s.a469fd10.jpg";